import React, { useState, useEffect } from 'react';
import { LIST_CL_IMAGES_YELP } from '../../../utils';
import axios from 'axios';
import { Check } from 'lucide-react';
import { useSelector } from 'react-redux';
import { selectedClientSelector } from '../../../store/slices/selectedClient';

const YelpGallery = (props) => {
  const maxHeight = props.maxHeight || '1505px';
  const { selectedClient } = useSelector(selectedClientSelector);
  const [images, setImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    setImages([]);
    setSelectedImage(null);
  }, [props.userId]);

  useEffect(() => {
    const getImages = async () => {
      if (props.userId) {
        try {
          const response = await axios.get(
            `${LIST_CL_IMAGES_YELP}/${selectedClient.id}`
          );
          if (response.data.length) {
            console.log('yelp response: ', response.data);
            setImages(response.data.reverse());
          }
        } catch (err) {
          console.error(err);
        }
      }
    };

    getImages();
  }, [props.userId]);

  return (
    <div
      className="grid grid-cols-3 gap-3 overflow-y-auto"
      style={{ maxHeight }}>
      {images.length ? (
        images.map((data, idx) => {
          const urlOriginal = data?.SK;
          const isUsed = data?.isUsed;
          const isSelected = selectedImage === urlOriginal;
          return (
            <div
              key={idx}
              className={`relative cursor-pointer rounded-xl overflow-hidden border-2 transition-all aspect-square ${
                isSelected
                  ? 'border-primary ring-2 ring-primary/20'
                  : 'border-transparent hover:border-muted-foreground/30'
              }`}
              style={{ background: '#f8fafc' }}
              onClick={() => {
                setSelectedImage(urlOriginal);
                if (!props.clientName) {
                  props.setAppImage({
                    pk: data.PK,
                    sk: urlOriginal
                  });
                }
              }}>
              <img
                src={urlOriginal}
                alt={`Yelp ${idx + 1}`}
                className="w-full h-full object-cover"
              />
              {isUsed && (
                <div className="absolute bottom-1.5 left-1.5 bg-muted-foreground/80 text-white text-[10px] font-semibold px-1.5 py-0.5 rounded-md">
                  Used
                </div>
              )}
              {isSelected && (
                <div className="absolute inset-0 bg-primary/20 flex items-center justify-center">
                  <Check className="h-6 w-6 text-primary-foreground bg-primary rounded-full p-1" />
                </div>
              )}
            </div>
          );
        })
      ) : (
        <div className="min-h-[200px] flex items-center justify-center text-muted-foreground col-span-3">
          <p className="text-base">No photos</p>
        </div>
      )}
    </div>
  );
};

export default YelpGallery;
